import {
  GDSStyleObject,
  StackLayout,
  UtilityText,
} from '@leagueplatform/genesis-core';
import * as React from 'react';

export type TagEmphasis = 'default' | 'subdued' | 'strong';

export interface TagProps {
  label: string;
  css?: GDSStyleObject;
  emphasis?: TagEmphasis;
}
export const Tag: React.FC<TagProps> = ({ label, css, ...props }: TagProps) => (
  <StackLayout
    css={{
      borderStyle: 'solid',
      borderWidth: '$thin',
      borderColor: '$onSurfaceBorderSubdued',
      backgroundColor: '$surfaceBackgroundSecondary',
      display: 'inline-flex',
      textWrap: 'nowrap',
      padding: '$quarter',
    }}
    {...props}
  >
    <UtilityText size="xs" css={{ fontWeight: '$medium' }}>
      {label}
    </UtilityText>
  </StackLayout>
);
